/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaPaisVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaPais: React.FunctionComponent<ITablaPaisVistaProps & InjectedIntlProps> = ({
    paiss,
    cargarPais,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={paiss}
            actions={acciones(manejarFormulario, cargarPais, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaPais);
